module.exports = __webpack_public_path__ + "static/ceramic-flower_3hx10lin-0ee78a57e5087bc4db714e73c0074823.jpg";